"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Carousel = void 0;
// New and temporary carousel component for PLP-277 test
var react_1 = __importStar(require("react"));
var Image_1 = __importDefault(require("../image/Image"));
var classnames_1 = __importDefault(require("classnames"));
var carousel_module_scss_1 = __importDefault(require("./carousel.module.scss"));
var Carousel = function (_a) {
    var _b, _c, _d;
    var _e = _a.images, images = _e === void 0 ? [] : _e, width = _a.width, _f = _a.initialSlide, initialSlide = _f === void 0 ? 0 : _f, _g = _a.currentSlide, currentSlide = _g === void 0 ? 0 : _g, setCurrentSlide = _a.setCurrentSlide, _h = _a.carouselCanUnload, carouselCanUnload = _h === void 0 ? false : _h, _j = _a.setShowCarousel, setShowCarousel = _j === void 0 ? function () { } : _j, url = _a.url, imageSettings = _a.imageSettings, _k = _a.title, title = _k === void 0 ? '' : _k;
    var carouselElement = (0, react_1.useRef)(null);
    var _l = (0, react_1.useState)(false), isAnimating = _l[0], setIsAnimating = _l[1];
    var _m = (0, react_1.useState)(false), hasLoaded = _m[0], setHasLoaded = _m[1];
    var animateToFirstSlideOnHover = false;
    var updateCarouselScroll = (0, react_1.useCallback)(function (targetSlide) {
        var carouselElementCurrent = carouselElement.current;
        if (carouselElementCurrent === null)
            return;
        if (!isAnimating &&
            carouselElementCurrent.scrollLeft !== targetSlide * width) {
            carouselElementCurrent.scrollTo({
                left: targetSlide * width,
                behavior: 'smooth',
            });
            setCurrentSlide(targetSlide);
            setIsAnimating(true);
        }
    }, [isAnimating, setCurrentSlide, width]);
    (0, react_1.useEffect)(function () {
        var carouselElementCurrent = carouselElement.current;
        // add event listener for  scrollLeft to reach target
        var handleScroll;
        if (isAnimating) {
            handleScroll = carouselElementCurrent.addEventListener('scroll', function () {
                if (currentSlide === 0 && carouselElementCurrent.scrollLeft > 0) {
                    return;
                }
                if (carouselElementCurrent.scrollLeft === currentSlide * width) {
                    setIsAnimating(false);
                }
            });
        }
        return function () {
            return carouselElementCurrent.removeEventListener('scroll', handleScroll);
        };
    }, [currentSlide, isAnimating, width]);
    (0, react_1.useEffect)(function () {
        if (initialSlide !== 0) {
            var carouselElementCurrent = carouselElement.current;
            var animateToSlide = animateToFirstSlideOnHover ? 1 : 0;
            if (initialSlide > animateToSlide) {
                carouselElementCurrent.scrollTo({
                    left: initialSlide * width,
                });
            }
            updateCarouselScroll(initialSlide);
        }
        setHasLoaded(true);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, react_1.useEffect)(function () {
        if (carouselCanUnload) {
            setTimeout(function () {
                setShowCarousel(false);
            }, 300);
        }
    }, [carouselCanUnload, setShowCarousel]);
    var handlePrevImageClick = (0, react_1.useCallback)(function () {
        if (isAnimating)
            return;
        var targetSlide;
        if (currentSlide > 0) {
            targetSlide = currentSlide - 1;
        }
        else {
            targetSlide = images.length - 1;
        }
        updateCarouselScroll(targetSlide);
    }, [isAnimating, currentSlide, updateCarouselScroll, images.length]);
    var handleNextImageClick = (0, react_1.useCallback)(function () {
        if (isAnimating)
            return;
        var targetSlide;
        if (currentSlide < images.length - 1) {
            targetSlide = currentSlide + 1;
        }
        else {
            targetSlide = 0;
        }
        updateCarouselScroll(targetSlide);
    }, [isAnimating, currentSlide, images.length, updateCarouselScroll]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("ul", { "data-testid": "carousel", className: (0, classnames_1.default)(carousel_module_scss_1.default.Carousel, (_b = {},
                _b[carousel_module_scss_1.default['Carousel--is-active']] = hasLoaded,
                _b[carousel_module_scss_1.default['Carousel--is-inactive']] = carouselCanUnload,
                _b)), style: { gridTemplateColumns: "repeat(".concat(images.length, ", 1fr)") }, ref: carouselElement, role: "group", "aria-label": "carousel" }, images.map(function (image, index) { return (react_1.default.createElement("li", { key: 'carouselimage' + index, className: carousel_module_scss_1.default.Carousel_item, style: {
                width: width,
            } },
            react_1.default.createElement(Image_1.default, __assign({ className: (0, classnames_1.default)(carousel_module_scss_1.default['c-product-card__image'], 'product__image', carousel_module_scss_1.default['Carousel_imageAnchor']), image: image, url: url, hasLoadingSpinner: "true" }, imageSettings)))); })),
        react_1.default.createElement("button", { className: (0, classnames_1.default)(carousel_module_scss_1.default.Carousel_button__prev, (_c = {},
                _c[carousel_module_scss_1.default['Carousel_button--is-hidden']] = carouselCanUnload,
                _c)), "data-testid": "prev-button", onClick: handlePrevImageClick },
            react_1.default.createElement("span", { className: carousel_module_scss_1.default.Carousel_buttonText },
                "View previous image ",
                title !== '' && "for ".concat(title))),
        react_1.default.createElement("button", { className: (0, classnames_1.default)(carousel_module_scss_1.default.Carousel_button__next, (_d = {},
                _d[carousel_module_scss_1.default['Carousel_button--is-hidden']] = carouselCanUnload,
                _d)), "data-testid": "next-button", onClick: handleNextImageClick },
            react_1.default.createElement("span", { className: carousel_module_scss_1.default.Carousel_buttonText },
                "View next image ",
                title !== '' && "for ".concat(title)))));
};
exports.Carousel = Carousel;
//# sourceMappingURL=carousel.js.map